import request from '@/utils/request'
import loginRequest from '@/utils/loginRequest'
import collectRequest from '@/utils/collectRequest'
import Qs from 'qs'


//配置list
export function allList(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/city-list',
		method: 'post',
		data: Qs.stringify(params)
	})
}

//获取周边的地块的地图接口
export function aroundLand(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/map-list',
		method: 'post',
		data: Qs.stringify(params)
	})
}


//获取周边的地块的地图接口
export function cityLand(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/map-list-new',
		method: 'post',
		data: Qs.stringify(params)
	})
}









export function cityInfo(params) {
    return loginRequest({
		url: '/frontend/cityshow/home/city-info',
		method: 'post',
		data: Qs.stringify(params)
	})
}



export function tradedata(params) {
    return loginRequest({
		url: '/frontend/cityshow/home/cj-data',
		method: 'post',
		data: Qs.stringify(params)
	})
}


export function tabledata(params) {
    return loginRequest({
		url: '/frontend/cityshow/home/table',
		method: 'post',
		data: Qs.stringify(params)
	})
}




//获取周边配套和宗地风险点的地图接口
export function zhoubianData(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/map-spot',
		method: 'post',
		params
	})
}


export function landDetail(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/detail',
		method: 'post',
		params
	})
}


export function LoginedlandDetail(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/detail',
		method: 'post',
		params
	})
}




export function getDetail(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/map-detail',
		method: 'post',
		params
	})
}

export function surveyChanyeOptions(params) {
	return collectRequest({
		url: '/frontend/cityshow/home/survey-gy-options',
		method: 'post',
		params
	})
}

// 产业地块问卷选项接口返回结构（示例）
// 用途：与 `src/views/website/collect/chanyesuggest.vue` 页面字段一一对应
export const surveyChanyeOptionsExample = {
	code: 1, // 接口状态码：1-成功，其他-失败
	msg: 'success', // 接口提示信息
	data: {
		intentionList: [
			{ id: 1, name: '高' },
			{ id: 2, name: '较高' },
			{ id: 3, name: '一般' },
			{ id: 4, name: '无' }
		], // 地块意向度（单选）选项
		ratioList: [
			{ id: 1, name: '10亩以下' },
			{ id: 2, name: '10-30亩' },
			{ id: 3, name: '30-50亩' },
			{ id: 4, name: '50-100亩以上' },
			{ id: 5, name: '100亩以上' }
		], // 意向用地面积（多选）选项
		watchList: [
			{ id: 1, name: '靠近高速公路出入口/交通主干道' },
			{ id: 2, name: '靠近港口/机场/铁路货运站' },
			{ id: 3, name: '靠近现有的产业链上下游集群' },
			{ id: 4, name: '靠近市区/便于员工通勤' },
			{ id: 99, name: '无特别要求，土地价格优惠即可' }
		], // 对地块位置的核心偏好（多选）选项
		innerlayoutList: [
			{ id: 1, name: '所属行业类别（主要业务方向）' },
			{ id: 2, name: '新一代信息技术' },
			{ id: 3, name: '高端装备制造' },
			{ id: 4, name: '生物医药/大健康' },
			{ id: 5, name: '新能源/新材料' },
			{ id: 6, name: '现代物流' },
			{ id: 7, name: '总部经济/研发中心' }
		], // 意向单位方面（多选）选项
		companyideaList: [
			{ id: 1, name: '初创期（需孵化场地）' },
			{ id: 2, name: '成长期（需扩大生产、有明确扩产计划）' },
			{ id: 3, name: '成熟期（需设立总部/研发基地）' },
			{ id: 4, name: '转型期（需要新设备/置换旧厂）' }
		], // 企业目前的发展阶段（多选）选项
		investList: [
			{ id: 1, name: '购买（50年产权工业用地/厂房）' },
			{ id: 2, name: '租赁（标准厂房/研发楼）' },
			{ id: 3, name: '合作共建（土地作价入股等）' }
		], // 计划获取方式（多选）选项
		totalInvestList: [
			{ id: 1, name: '2000万以下' },
			{ id: 2, name: '2000万-5000万' },
			{ id: 3, name: '5000万-1亿' },
			{ id: 4, name: '1亿-3亿' },
			{ id: 5, name: '3亿以上' }
		], // 预计总投资额（多选）选项
		extraFieldDesc: {
			watchOther: '对地块位置的核心偏好-其他文本',
			innerlayoutOther: '意向单位方面-其他文本',
			otherAdvice: '其他意见或建议文本'
		} // 页面自由输入字段说明（非下拉选项）
	}
}




export function saveSuggest(params) {
	return collectRequest({
		url: '/frontend/cityshow/home/survey-submit',
		method: 'post',
		params
	})
}



export function savegySuggest(params) {
	return collectRequest({
		url: '/frontend/cityshow/home/survey-gy-submit',
		method: 'post',
		params
	})
}



export function headerad(params) {
	return loginRequest({
		url: '/frontend/cityshow/home/header',
		method: 'post',
		params
	})
}












// http://dataapi.chinatupai.com:8080/api/frontend/cityshow/home/cj-data


// https://dataapi.chinatupai.com:447/api/frontend/bigdata/landdata/map-detail?id=51096&is_gaode=2

//申请资料
// export function loginedApply(params) {
// 	return request({
// 		url: '/frontend/website/bingo/data-apply',
// 		method: 'post',
// 		data: Qs.stringify(params)
// 	})
// }

